import SAJM_GLOBALS from "../constants";
import GlobalUser from "../models/User";

export class DonationController{

    /*
    
    Get List of all donations

    */

    async getDonations() {

        let url = SAJM_GLOBALS.GIVEWP_URL+"/v1/donations";
        let apiKey = SAJM_GLOBALS.GIVEWP_KEY;
        let token = SAJM_GLOBALS.GIVEWP_TOKEN;

        try {
            
            let params="key="+apiKey+"&token="+token;
            url = SAJM_GLOBALS.GIVEWP_URL+"/v1/donations/?" + params;

            const response = await fetch(url);
            
            if (!response.ok) {
                //debugger;
                throw Error(response.statusText);
            }

            return await response.json();

        }
        catch (error) {
            console.log("DonationController.getDonations:"+error);
            return undefined;
        }
    }

    /*
    
    Get Donation By Id

    */

    async getDonationByID(id) {

        let url = SAJM_GLOBALS.GIVEWP_URL+"/v1/donations";
        let apiKey = SAJM_GLOBALS.GIVEWP_KEY;
        let token = SAJM_GLOBALS.GIVEWP_TOKEN;

        try {
            
            let params="key="+apiKey+"&token="+token+"&id="+id;
            url = SAJM_GLOBALS.GIVEWP_URL+"/v1/donations/?" + params;

            const response = await fetch(url);
            
            if (!response.ok) {
                //debugger;
                throw Error(response.statusText);
            }

            return await response.json();

        }
        catch (error) {
            console.log("DonationController.getDonations:"+error);
            return undefined;
        }
    }


    /*
    
    Get Donation Comment history
    
    */ 

    async getDonationCommentsHistory(id){

        let apiKey = GlobalUser.getApiKey();
        let apiToken = GlobalUser.getToken();
        let apiFunctionParams =  "{\"comment_parent\": \""+id+"\"}";
        let apiFunctionName = "donationHisto_getComments";

        try {

            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({  apiFunctionName: apiFunctionName,
                                        apiFunctionParams: apiFunctionParams,
                                        apiKey: apiKey,
                                        apiToken: apiToken,
                                         })
            };

            let url = SAJM_GLOBALS.API_HOST+"/";
            const response = await fetch(url, requestOptions);

            if (!response.ok) {
                throw Error(response.statusText);
            }

            return await response.json();

        }
        catch(error){
            console.log("DonationController.getDonationCommentsHistory:"+error);
        }

    }

}
export default DonationController;